import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createPhlebotomist = createAsyncThunk(
  "phlebotomist/createPhlebotomist",

  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "phlebotomist/createPhlebotomist",
        data.formData,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getPhlebotomist = createAsyncThunk(
  "phlebotomist/getPhlebotomist",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/phlebotomist/getPhlebotomist", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
export const updatePhlebotomist = createAsyncThunk(
  "phlebotomist/updatePhlebotomist",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "phlebotomist/updatePhlebotomist",
        {
          id: data.id,
          mobileNo: data.mobileNo,
          email: data.email,
          status: data.status,
        },
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.result?.message ||
          error.response?.data?.message ||
          error.message,
      );
    }
  },
);

const initialState = {
  phlebotomist: [],

  isLoading: false,

  createPhlebotomistSuccessMessage: null,

  createPhlebotomistErrorMessage: null,
  updatePhlebotomistSuccessMessage: null,
  updatePhlebotomistErrorMessage: null,

  searchMessage: null,

  currentPage: 1,

  totalPages: null,

  totalCount: 0,

  hasMore: true,
};

const phlebotomistSlice = createSlice({
  name: "phlebotomist",

  initialState,

  reducers: {
    resetCreateMessages: (state) => {
      state.createPhlebotomistSuccessMessage = null;

      state.createPhlebotomistErrorMessage = null;
    },
    resetUpdateMessages: (state) => {
      state.updatePhlebotomistSuccessMessage = null;
      state.updatePhlebotomistErrorMessage = null;
    },
  },

  extraReducers: (builder) => {
    builder

      // CREATE PHLEBOTOMIST

      .addCase(createPhlebotomist.pending, (state) => {
        state.isLoading = true;

        state.createPhlebotomistSuccessMessage = null;

        state.createPhlebotomistErrorMessage = null;
      })

      .addCase(createPhlebotomist.fulfilled, (state, action) => {
        state.isLoading = false;

        if (action.payload.success === false) {
          state.createPhlebotomistErrorMessage = action.payload.result.message;
        } else {
          state.createPhlebotomistSuccessMessage =
            action.payload.result.message;
        }
      })

      .addCase(createPhlebotomist.rejected, (state, action) => {
        state.isLoading = false;

        state.createPhlebotomistErrorMessage = action.payload;
      })

      .addCase(getPhlebotomist.pending, (state) => {
        state.loading = true;
      })

      .addCase(getPhlebotomist.fulfilled, (state, action) => {
        state.loading = false;
       state.phlebotomist = action.payload.result.list;
        state.totalCount = action.payload.result.totalCount;
        state.currentPage = action.payload.result.currentPage;
        state.totalPages = action.payload.result.totalPages;
      })

      .addCase(getPhlebotomist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // UPDATE PHLEBOTOMIST
      .addCase(updatePhlebotomist.pending, (state) => {
        state.isLoading = true;
      })

      .addCase(updatePhlebotomist.fulfilled, (state, action) => {
        state.isLoading = false;

        if (action.payload.success === false) {
          state.updatePhlebotomistErrorMessage = action.payload.result.message;
        } else {
          state.updatePhlebotomistSuccessMessage =
            action.payload.result.message;
        }
      })

      .addCase(updatePhlebotomist.rejected, (state, action) => {
        state.isLoading = false;
        state.updatePhlebotomistErrorMessage = action.payload;
      });
  },
});

export const { resetCreateMessages } = phlebotomistSlice.actions;

export default phlebotomistSlice.reducer;
